import ScanInput from './scanInput';

export default ScanInput;
